import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllTDSAction = createAsyncThunk(
    'report/fetchAllTDSReport',
    async ({year , month} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/tds_report?year=${year}&month=${month}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all TDS');
        }
    }
);
export const fetchAllTDSMonthlyCount = createAsyncThunk(
    'report/fetchAllTDSReportMonthlyCount',
    async ( year : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/tds_report/monthly?year=${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all TDS');
        }
    }
);
export const fetchAllTDSCount = createAsyncThunk(
    'report/fetchAllTDSReportCount',
    async ( {year , month}: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/tds_report/all/count?year=${year}&month=${month}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all TDS');
        }
    }
);